import React from 'react';
import PropTypes from 'prop-types';
import PencilIcon from '@bufferapp/ui/Icon/Icons/Pencil';
import CanvaIcon from '@bufferapp/ui/Icon/Icons/Canva';
import MessageIcon from '@bufferapp/ui/Icon/Icons/Message';
import { carouselCardPropTypes } from '../../../utils/commonPropTypes';
import {
  StyledCrossIcon,
  CrossIconWrapper,
  DragDropWrapper,
  HoverWrapper,
  EditButtonsWrapper,
  StyledButton,
  NoteButton,
} from './style';

const CarouselCardHover = ({
  card,
  onAddNoteClick,
  onDeleteStoryClick,
  onEditCanvaImageClick,
  translations,
  onEditButtonClick,
}) => (
  <HoverWrapper>
    <CrossIconWrapper data-tip="Remove" role="button">
      <StyledCrossIcon size="medium" onClick={() => onDeleteStoryClick(card)} />
    </CrossIconWrapper>
    <DragDropWrapper />
    <EditButtonsWrapper>
      <NoteButton
        icon={<MessageIcon />}
        onClick={() => onAddNoteClick(card)}
        label={card.note ? translations.editNote : translations.addNote}
        tooltip={card.note}
        size="small"
      />
      {card.type === 'image' && (
        <StyledButton
          icon={<PencilIcon />}
          hasIconOnly
          onClick={() => onEditButtonClick()}
          tooltip="Edit"
          size="small"
        />
      )}
      {card.source?.name === 'canva' && (
        <StyledButton
          icon={<CanvaIcon />}
          hasIconOnly
          onClick={() => onEditCanvaImageClick()}
          tooltip="Edit"
          size="small"
        />
      )}
    </EditButtonsWrapper>
  </HoverWrapper>
);

CarouselCardHover.propTypes = {
  card: carouselCardPropTypes, // eslint-disable-line react/require-default-props,
  translations: PropTypes.shape({
    addNote: PropTypes.string.isRequired,
  }).isRequired,
  onAddNoteClick: PropTypes.func,
  onDeleteStoryClick: PropTypes.func,
  onEditCanvaImageClick: PropTypes.func,
  onEditButtonClick: PropTypes.func,
};

CarouselCardHover.defaultProps = {
  onAddNoteClick: () => {},
  onDeleteStoryClick: () => {},
  onEditCanvaImageClick: () => {},
  onEditButtonClick: () => {},
};

export default CarouselCardHover;
